import { ENVIRONMENT } from '@/shared/conf';

export function getAccessTokenCookieName(): string {
  return ENVIRONMENT === 'stage' ? 'stageAccessToken' : 'accessToken';
}

export function getRefreshTokenCookieName(): string {
  return ENVIRONMENT === 'stage' ? 'stageRefreshToken' : 'refreshToken';
}
